import { render, staticRenderFns } from "./suppressors-data.vue?vue&type=template&id=5bfee06f&scoped=true"
import script from "./suppressors-data.vue?vue&type=script&lang=js"
export * from "./suppressors-data.vue?vue&type=script&lang=js"
import style0 from "./suppressors-data.vue?vue&type=style&index=0&id=5bfee06f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bfee06f",
  null
  
)

export default component.exports